import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
    root: {
        borderRadius: '4px',
        height: '100px',
        width: 'calc(100% - 8px)',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#141b33',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
        resize: 'none',
        overflowY: 'scroll'
    }
}))

const FieldTextarea = ({
    name,
    placeholder,
    register
}) => {
    const classes = useStyles();

    return (
        <label htmlFor={name}>
            <textarea 
                {...register(name)}
                className={classes.root}
                placeholder={placeholder}
            />
        </label>
    )
}

export default FieldTextarea;